import { BsArrowUpRight } from "@react-icons/all-files/bs/BsArrowUpRight";
import { Link } from "gatsby";
import React from "react";
import excerptAstToText from "../util/excerptAstToText";
import * as css from "./BlogPostExcerpt.module.css";
import ExcerptDetails from "./ExcerptDetails";
import Metadata from "./Metadata";

type BlogPostExcerptProps = {
  data: Queries.NodeForBlogIndexFragment;
  elementType?: string;
};

export default function BlogPostExcerpt({
  data,
  elementType = "div",
}: BlogPostExcerptProps) {
  if (!data.fields || !data.frontmatter || !data.fields.slug) {
    return null;
  }

  const { author, authorHref, date, description } = data.frontmatter;
  const metadata = (
    <Metadata author={author} authorHref={authorHref} date={date} />
  );

  const excerpt = excerptAstToText(data.excerptAst);

  return React.createElement(
    elementType,
    { className: css.blogPostExcerpt },
    <div className={css.inner}>
      <ExcerptDetails
        tags={data.frontmatter.tags}
        timeToRead={data.timeToRead}
      />
      <div className={css.bottom}>
        <div className={css.left}>
          <header>
            <h1>
              <Link to={data.fields.slug} data-cy="blog-title">
                {data.frontmatter.title}
              </Link>
            </h1>
          </header>
          <div className={css.mobileMetadata} data-cy="blog-metadata-mobile">
            {metadata}
          </div>
          <p className={css.excerpt} data-cy="blog-excerpt">
            {description ?? excerpt}
          </p>
          <Link to={data.fields.slug} className={css.readMore}>
            Read More <BsArrowUpRight />
          </Link>
        </div>
        <div className={css.metadata} data-cy="blog-metadata">
          {metadata}
        </div>
      </div>
    </div>
  );
}
